import React, { useEffect, useState } from "react";
import { Form, Col, Row, Modal } from "react-bootstrap";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import Button from "../../../components/Button";
import { useUser } from "../../../components/UserContext";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { getDriverNameLink } from "../../../utils/Standings";
import { Link } from "react-router-dom";
import Flag from "../../../components/Flag";
import { useTranslation } from "react-i18next";
import DataTable from "react-data-table-component";
import moment from "moment";

interface Cost {
  year: number;
  money: number;
  description: string;
}

interface ChargeSummary {
  year: number;
  charges: number;
  donations: number;
  differential: number;
  total_donations: number;
}

const Charges = () => {
  const { t } = useTranslation();
  const { access } = useIsAdmin();
  document.title = "LVF1 - Charges";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [theme, setTheme] = useState("light");
  const [update, setUpdate] = useState(false);
  const [update2, setUpdate2] = useState(false);
  const [typeTable, setTypeTable] = useState(-1);
  const [costs, setCosts] = useState<Cost[]>();
  const [chargesSummary, setChargesSummary] = useState<ChargeSummary[]>();
  const [showModal, setShowModal] = useState(false);
  const [columns, setColumns] = useState<ColumnData[]>([]);
  const [balance, setBalance] = useState(0);
  const [rows, setRows] = useState<{ [key: string]: any }[]>([]);

  const [formData, setFormData] = useState({
    year: "",
    amount: "",
    description: "",
  });

  useEffect(() => {
    const theme_ = window.localStorage.getItem("theme");
    setTheme(theme_ != null && theme_ === "light" ? "dark" : "light");
  }, [window.localStorage.getItem("theme")]);

  const inputChange = ({ target }: { target: any }) => {
    const { name, value } = target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    let rows_: any = [];
    if (typeTable === 1) {
      let columns_: ColumnData[] = [
        {
          name: "Year",
          selector: (row: { [key: string]: any }) => row.year,
          sortable: true,
          width: "100px",
        },
        {
          name: "Charges (€)",
          selector: (row: { [key: string]: any }) => row.charges,
          sortable: true,
          width: "150px",
        },
        {
          name: "Donations (€)",
          selector: (row: { [key: string]: any }) => row.donations,
          sortable: true,
          width: "150px",
        },
        {
          name: "Total Donations",
          selector: (row: { [key: string]: any }) => row.total_donations,
          sortable: true,
          width: "150px",
        },
        {
          name: "Differential (€)",
          selector: (row: { [key: string]: any }) => row.total,
          sortable: true,
          width: "150px",
        },
      ];
      setColumns(columns_);

      chargesSummary?.forEach((driver: ChargeSummary) => {
        let row_: { [key: string]: any } = {
          year: driver.year,
          charges: driver.charges.toFixed(2),
          donations: driver.donations.toFixed(2),
          total_donations: driver.total_donations,
          total:
            driver.differential >= 0 ? (
              <b className="green">+{driver.differential.toFixed(2)}</b>
            ) : (
              <b className="red">
                -{driver.differential.toFixed(2).toString().split("-")[1]}
              </b>
            ),
        };
        rows_.push(row_);
      });
    } else {
      let columns_: ColumnData[] = [
        {
          name: "Year",
          selector: (row: { [key: string]: any }) => row.year,
          sortable: true,
          width: "150px",
        },
        {
          name: "Money (€)",
          selector: (row: { [key: string]: any }) => row.money,
          sortable: true,
          width: "150px",
        },
        {
          name: "Description",
          selector: (row: { [key: string]: any }) => row.description,
          sortable: true,
          width: "300px",
        },
      ];
      setColumns(columns_);

      costs?.forEach((cost: Cost) => {
        let row_: { [key: string]: any } = {
          money: cost.money.toFixed(2),
          year: cost.year,
          description: cost.description,
        };
        rows_.push(row_);
      });
    }
    setRows(rows_);
  }, [update2]);

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/general/getCosts`,
      )
      .then(({ data }) => {
        setCosts(data.charges);
        setChargesSummary(data.chargesSummary);
        setTypeTable(1);
        setUpdate2(!update2);
        var total = 0;
        data.chargesSummary.forEach((data: any) => {
          total += data.differential;
        });
        setBalance(total);
      })
      .catch(({ response }) => {
        throw new Error(response);
      });
  }, [update]);

  const handleSubmit = (event: React.FormEvent) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();

    const formDataFiles = new FormData();
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);
    formDataFiles.append("year", formData.year);
    formDataFiles.append("amount", formData.amount);
    formDataFiles.append("description", formData.description);

    axios
      .post(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/admin/addCost`,
        formDataFiles,
      )
      .then(() => {
        toast.success("Cost added successfully");
        setUpdate(!update);
        setShowModal(false);
      })
      .catch(({ response }) => {
        toast.error(response.data.message);
        throw new Error(response);
      });
  };

  if (!access) return <ErrorPage />;

  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container-md overflowed">
        <Title text="Charges" />

        {/* BOTÓN */}
        <Button text={"Add Charge"} onClick={() => setShowModal(true)} />

        {/* MODAL */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Add Charge</Modal.Title>
          </Modal.Header>

          <Form onSubmit={handleSubmit}>
            <Modal.Body>
              <Row className="mb-3">
                <Col>
                  <Form.Label>Year</Form.Label>
                  <Form.Control
                    type="number"
                    name="year"
                    value={formData.year}
                    onChange={(e) => inputChange(e)}
                    required
                  />
                </Col>

                <Col>
                  <Form.Label>Money (€)</Form.Label>
                  <Form.Control
                    type="number"
                    name="amount"
                    value={formData.amount}
                    onChange={(e) => inputChange(e)}
                    required
                  />
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  name="description"
                  value={formData.description}
                  onChange={inputChange}
                  required
                />
              </Form.Group>
            </Modal.Body>

            <Modal.Footer>
              <Button
                text={"Close"}
                onClick={() => setShowModal(false)}
                className="button-neutral-lvf1"
              />
              <Button text={"Save Cost"} type="submit" />
            </Modal.Footer>
          </Form>
        </Modal>
        <div className="flex-center">
          <div className="table-stats-container relative table-donors">
            <Button
              text={typeTable === 1 ? "Show all Charges" : "Show Summary"}
              onClick={() => {
                setTypeTable(typeTable === 1 ? 0 : 1);
                setUpdate2(!update2);
              }}
              className="button-neutral-lvf1"
            />
            <div>
              <DataTable
                columns={columns}
                data={rows}
                pagination
                theme={theme}
                paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
                paginationComponentOptions={{
                  selectAllRowsItem: true,
                  selectAllRowsItemText: t("All"),
                  rowsPerPageText: t("RowsPerPage"),
                  rangeSeparatorText: t("of"),
                }}
              />
            </div>
          </div>
        </div>
        {typeTable === 1 && (
          <p id="balance-text">
            TOTAL BALANCE:{" "}
            <span className={balance >= 0 ? "green" : "red"}>
              {balance >= 0 ? "+" : ""}
              {balance.toFixed(2)} €
            </span>
          </p>
        )}
      </div>
    </div>
  );
};

export default Charges;
